import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.financial.'

@vsingleton()
export class AdminInvoiceRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'invoices.'

  index() {
    return this.ziggyRoute('index')
  }

  create() {
    return this.ziggyRoute('create')
  }

  store() {
    return this.ziggyRoute('store')
  }

  show(invoiceId: number) {
    return this.ziggyRoute('show', invoiceId)
  }

  update(invoiceId: number) {
    return this.ziggyRoute('update', invoiceId)
  }

  destroy(invoiceId: number) {
    return this.ziggyRoute('destroy', invoiceId)
  }

  download(invoiceId: number) {
    return this.ziggyRoute('download', invoiceId)
  }
}
